import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import fr from 'facet-rest';
import Button from 'Components/UI/Button';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import FAQQuestion, { metaOverrideSet as FAQQuestionMetaOverrideSet } from './FAQQuestion';

const useStyles = buildUseStyles('AccountPerformanceDashboard', () => ({
  root: {
  },
  metaFormInline: {
    padding: 0,
    backgroundColor: 'inherit',
  },
}));

export default function FAQ() {
  const classes = useStyles();

  const { resource } = useMetaLayoutContext();

  return (
    <Box>
      <Box marginBottom={2}><MetaControlField attr="title" /></Box>
      <MetaControlField attr="subtitle" />
      {resource.attr('questions').resources().list().map((question) => (
        <React.Fragment id={question.attr('id')}>
          <MetaFormInline
            className={classes.metaFormInline}
            resource={question}
            noIndividualSubmitButtons
            layout={FAQQuestion}
            metaOverrideSet={FAQQuestionMetaOverrideSet}
          />
        </React.Fragment>
      ))}
      {!!resource.relationship(fr.relationships.externalLink.name) && (
        <a href={resource.relationship(fr.relationships.externalLink.name).link('related').url()} target={'_blank'}>
          <Button
            startIcon={<OpenInNewIcon />}
            variant={'text'}
            color={'primary'}
          >
            {resource.relationship(fr.relationships.externalLink.name).meta('label')}
          </Button>
        </a>
      )}
    </Box>
  );
}
